'use client'

import type { TransitionEvent } from 'react'
import { cx } from 'utils/cx'
import { useChatBotMessages } from '../../hooks/useChatBotMessages'
import type { ReplyOrderListMessage } from '../../types/messageTypes'
import styles from './OrderList.module.scss'
import { OrderProductsCard } from './OrderProductsCard/OrderProductsCard'

export const OrderList = ({
	message,
}: { readonly message: ReplyOrderListMessage }) => {
	const { deleteChoices, shouldFadeoutMessages } = useChatBotMessages()

	const onOrderCardTransitionEnd = (e: TransitionEvent<HTMLDivElement>) => {
		if (e.propertyName === 'opacity') {
			deleteChoices()
		}
	}

	return (
		<div
			className={cx(styles.orderCard, shouldFadeoutMessages && styles.hidden)}
			onTransitionEnd={onOrderCardTransitionEnd}
		>
			{message.orders.map((order) => (
				<div key={`${order.date}${order.title}`}>
					<div className={styles.imageContainer} />
					<OrderProductsCard
						products={order.products}
						orderTitle={order.title}
					/>
					<div className={styles.orderInfoContainer}>
						<p>{order.title}</p>
						<p>{order.date}</p>
						<p>{order.price}</p>
					</div>
				</div>
			))}
		</div>
	)
}
